import { Injectable } from '@angular/core';
import {
  BaseServiceErrorResolverService
} from '../../../../core/services/error-resolvers/base-service-error-resolver.service';

@Injectable({
  providedIn: 'root'
})
export class ArticleLabelsErrorResolverService extends BaseServiceErrorResolverService {

  public override codes = {
    'LabelAlreadyExistsInVariant': 'Für die ausgewählte Artikelvariante existiert bereits ein Etikett dieses Typs.',
    InvalidEanCode: 'Die EAN des Artikels ist nicht gültig.',
  };
}
